export default __webpack_public_path__ + "/assets/fonts/materialdesignicons-webfont.eot";